.view-picker {
    display: flex;
    align-items: flex-start;
    border-radius: 4px;
    border: 2px solid var(--off-white-dk);
    background: var(--off-white);
    height: 32px;
    box-sizing: border-box;
}

.view-tab {
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    margin: -2px 0 -2px -1px;
}

.view-tab:first-child {
    margin-left: -2px;
}

.view-tab:last-child {
    margin-right: -2px;
}

.view-tab-active {
    composes: view-tab;
    border: 2px solid var(--blue);
}

.view-tab:hover {
    background-color: var(--white);
    height: 28px;
    width: 30px;
    margin: 0 1px 0 0;
}

.view-tab:hover:first-child {
    margin-right: 2px;
    width: 28px;
}

.view-tab:hover:last-child {
    margin-right: 0;
    margin-left: 1px;
    width: 28px;
}

.view-tab-active:hover {
    background-color: var(--white);
    height: 32px;
    width: 32px;
    margin: -2px 0 -2px -1px;
}

.view-tab-active:hover:first-child {
    margin-left: -2px;
    margin-right: 0;
    width: 32px;
}

.view-tab-active:hover:last-child {
    margin-right: -2px;
    margin-left: -1px;
    width: 32px;
}

.view-tab button:focus,
.view-tab a:focus,
.view-tab button:focus-visible,
.view-tab a:focus-visible {
    background: none;
    outline: var(--focus-blue) solid 2px;
    outline-offset: -2px;
    border-radius: 4px;
    z-index: 100;
}

/* Removes focus style on non-keyboard input (i.e. mouse click) */
.view-tab button:focus:not(:focus-visible),
.view-tab a:focus:not(:focus-visible) {
    outline: none;
    border-radius: 0;
}

.view-tab-active button:focus-visible,
.view-tab-active a:focus-visible,
.view-tab-active button:focus,
.view-tab-active a:focus {
    background: none;
    outline: var(--focus-blue) solid 2px;
    outline-offset: 0;
    border-radius: 2px;
    z-index: 100;
}
